import { __decorate } from "tslib";
import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import { dataMapper } from "@/services/store/modules/data/store";
import { uiMapper } from "@/services/store/modules/ui/store";
import IconSvg from "@/components/IconSvg.vue";
import ButtonApp from "@/components/ButtonApp.vue";
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapState(["phone", "whatsapp"]),
        ...dataMapper.mapGetters(["formMail"]),
    },
    methods: {
        ...dataMapper.mapMutations([
            "setFormCallTitle",
            "setFormCallScreen",
            "deactivateFormField",
            "activateFormField",
            "clearForm",
        ]),
    },
});
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(["breakpoint", "windowWidth"]),
    },
    methods: {
        ...uiMapper.mapMutations(["closeFormCall", "openFormCall", "openFormPay"]),
    },
});
let NavbarApp = class NavbarApp extends Mixins(DataMappers, UiMappers) {
    get isLtMd() {
        return this.breakpoint === "xs" || this.breakpoint === "sm";
    }
    get isGtLg() {
        return this.breakpoint === "lg" || this.breakpoint === "xl";
    }
    get isSm() {
        return this.breakpoint === "sm";
    }
    get isXs() {
        return this.breakpoint === "xs";
    }
    get isTabletAndMobile() {
        return this.windowWidth < 1240;
    }
    get formCallMail() {
        return this.formMail("callback");
    }
    async onOpenFormClick() {
        this.clearForm("callback");
        await this.$nextTick();
        this.setFormCallTitle("Перезвоните мне");
        this.setFormCallScreen("Модальное окно 'Перезвоните мне' / Шапка сайта");
        this.deactivateFormField(this.formCallMail);
        this.openFormCall();
    }
    async onOpenFormBooking() {
        this.clearForm("callback");
        await this.$nextTick();
        this.setFormCallTitle("Забронировать смену");
        this.setFormCallScreen("Модальное окно 'Забронировать смену' / Шапка сайта");
        this.activateFormField(this.formCallMail);
        this.openFormCall();
    }
};
__decorate([
    Prop()
], NavbarApp.prototype, "isFooter", void 0);
NavbarApp = __decorate([
    Component({
        components: {
            IconSvg,
            ButtonApp,
        },
        filters: {
            phoneDisplay: (value) => {
                if (!value)
                    return;
                const res = "+7 (" +
                    value.slice(2, 5) +
                    ") " +
                    value.slice(5, 8) +
                    "-" +
                    value.slice(-4);
                return res;
            },
        },
    })
], NavbarApp);
export default NavbarApp;
